import React from 'react';
import { 
  FaChevronRight, 
  FaSearch, 
  FaCalendarAlt, 
  FaComment, 
  FaUser, 
  FaArrowRight,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaHeart,
  FaShareAlt,
  FaBookmark,
  FaEye,
  FaTag,
  FaStar,
  FaFilter,
  FaNewspaper,
  FaFire,
  FaBrain,
  FaFemale,
  FaBaby,
  FaChartLine,
  FaClock,
  FaBookOpen
} from 'react-icons/fa';
import '../style.css';

const BlogSection = () => {
  const featuredPosts = [
    {
      id: 1,
      category: "Motherhood",
      title: "डिलीवरी के बाद ब्लीडिंग – क्या सामान्य है और कब हो सकती है खतरे की घंटी?",
      excerpt: "माँ बनना हर महिला के जीवन का सबसे सुंदर अनुभव होता है। लेकिन इस खुशी के साथ-साथ डिलीवरी के बाद शरीर में कई बदलाव भी आते हैं...",
      date: "30 Aug 2025",
      readTime: "5 min",
      author: "Dr. Priya Sharma",
      image: "https://www.verywellhealth.com/thmb/CGcSSMzWLdk01zeVwqT1-A0vBBM=/5121x3414/filters:fill(87E3EF,1)/doctors-talking-to-patient-in-hospital-icu-493216255-583452e15f9b58d5b1b967c7.jpg",
      likes: 42,
      views: "1.2K",
    },
    {
      id: 2,
      category: "Neurology",
      title: "माइग्रेन से राहत: आधुनिक उपचार और घरेलू उपाय",
      excerpt: "माइग्रेन एक सामान्य न्यूरोलॉजिकल समस्या है जो लाखों लोगों को प्रभावित करती है...",
      date: "28 Aug 2025",
      readTime: "6 min",
      author: "Dr. Rajesh Kumar",
      image: "https://media.istockphoto.com/photos/intensive-care-picture-id157280378?k=20&m=157280378&s=612x612&w=0&h=c9cXqlWI6AFFspDpf3RYTStMEwrbIZ3PZDRcGm-QcCg=",
      likes: 56,
      views: "2.1K",
      trending: true,
      color: "#4f46e5"
    }
  ];

  const recentPosts = [
    {
      id: 3,
      category: "Infertility",
      title: "आईवीएफ उपचार: प्रक्रिया और सफलता दर",
      excerpt: "आईवीएफ (इन विट्रो फर्टिलाइजेशन) उन जोड़ों के लिए एक प्रभावी उपचार है...",
      date: "25 Aug 2025",
      readTime: "8 min",
      author: "Dr. Anjali Singh",
      image: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      likes: 28,
      views: "1.5K",
      color: "#10b981"
    },
    {
      id: 4,
      category: "Pediatrics",
      title: "नवजात शिशु की देखभाल: आवश्यक टिप्स",
      excerpt: "नवजात शिशु की देखभाल माता-पिता के लिए एक नया अनुभव होता है...",
      date: "22 Aug 2025",
      readTime: "7 min",
      author: "Dr. Ravi Verma",
      image: "https://3.bp.blogspot.com/-aG-Bnyo9I5g/V1fP9OIHhFI/AAAAAAAAmoI/8j63W5nsru8_U3ZrZWvrWt31GjqRI-L5ACLcB/w1200-h630-p-k-no-nu/surgery%2B1.jpg",
      likes: 35,
      views: "1.8K",
      color: "#06b6d4"
    },
    {
      id: 5,
      category: "Wellness",
      title: "तनाव प्रबंधन: आधुनिक जीवन शैली में स्वस्थ रहने के उपाय",
      excerpt: "आज की तेजी से भागती दुनिया में तनाव एक आम समस्या बन गया है...",
      date: "20 Aug 2025",
      readTime: "6 min",
      author: "Dr. Neha Gupta",
      image: "https://w2pcms.com/wp-content/uploads/sites/10/2023/08/36998834_SJ.CITroboticsurgery.P.08132304.jpg?w=1024",
      likes: 49,
      views: "1.7K",
      color: "#f59e0b"
    }
  ];

  const popularPosts = [
    {
      id: 6,
      category: "Neurology",
      title: "अल्जाइमर रोग: लक्षण, कारण और रोकथाम",
      excerpt: "अल्जाइमर रोग एक प्रगतिशील न्यूरोलॉजिकल विकार है...",
      date: "18 Aug 2025",
      readTime: "9 min",
      author: "Dr. Amit Patel",
      image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: "2.5K",
      color: "#8b5cf6"
    },
    {
      id: 7,
      category: "Motherhood",
      title: "गर्भावस्था में पोषण का महत्व और आहार योजना",
      excerpt: "गर्भावस्था के दौरान सही पोषण माँ और बच्चे दोनों के लिए...",
      date: "15 Aug 2025",
      readTime: "7 min",
      author: "Dr. Smita Desai",
      image: "https://images.unsplash.com/photo-1542736667-069246bdbc6d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80",
      views: "2.1K",
      color: "#ec4899"
    }
  ];

  const categories = [
    { name: "All Articles", count: 15, icon: <FaNewspaper /> },
    { name: "Neurology", count: 8, icon: <FaBrain /> },
    { name: "Motherhood", count: 5, icon: <FaFemale /> },
    { name: "Infertility", count: 3, icon: <FaHeart /> },
    { name: "Pediatrics", count: 6, icon: <FaBaby /> },
    { name: "Wellness", count: 4, icon: <FaStar /> }
  ];

  const tags = [
    "Neurology", "Motherhood", "Infertility", "Pediatrics", "Wellness", 
    "Treatment", "Care", "Health Tips", "Medication", "Recovery", 
    "Prevention", "Nutrition"
  ];

  return (
    <div className="blog-v2">
      {/* Hero Section */}
      <div className="blog-hero-v2">
        <div className="container-v2">
          <div className="hero-content-v2">
            <nav className="breadcrumb-v2">
              <a href="/">Home</a>
              <FaChevronRight className="separator" />
              <a href="/medical">Medical</a>
              <FaChevronRight className="separator" />
              <span className="current">Health Blog</span>
            </nav>
            
            <div className="hero-main-v2">
              <div className="hero-text">
                <h1>Medical Insights & Health Blog</h1>
                <p className="subtitle">
                  Expert medical advice, latest research updates, and health tips from 
                  Rockland's team of specialists
                </p>
              </div>
              
              <div className="hero-stats">
                <div className="stat-item">
                  <FaBookOpen />
                  <div>
                    <span className="stat-number">150+</span>
                    <span className="stat-label">Articles</span>
                  </div>
                </div>
                <div className="stat-item">
                  <FaUser />
                  <div>
                    <span className="stat-number">25+</span>
                    <span className="stat-label">Experts</span>
                  </div>
                </div>
                <div className="stat-item">
                  <FaEye />
                  <div>
                    <span className="stat-number">50K+</span>
                    <span className="stat-label">Readers</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-v2">
        <div className="blog-layout-v2">
          {/* Left Column - Main Content */}
          <div className="main-content-v2">
            {/* Featured Articles */}
            <section className="section-v2">
              <div className="section-header-v2">
                <h2>
                  <FaFire className="icon" />
                  Featured Articles
                </h2>
                <p className="section-desc">Most read and recommended articles</p>
              </div>
              
              <div className="featured-grid-v2">
                {featuredPosts.map((post) => (
                  <article key={post.id} className="featured-card-v2">
                    <div className="card-image-v2">
                      <img src={post.image} alt={post.title} />
                      <div className="image-overlay" style={{ backgroundColor: `${post.color}20` }} />
                      <div className="category-tag" style={{ backgroundColor: post.color }}>
                        {post.category}
                      </div>
                      {post.trending && (
                        <div className="trending-badge">
                          <FaChartLine /> Trending
                        </div>
                      )}
                    </div>
                    
                    <div className="card-content-v2">
                      <div className="post-meta-v2">
                        <span className="meta-item">
                          <FaCalendarAlt /> {post.date}
                        </span>
                        <span className="meta-item">
                          <FaClock /> {post.readTime}
                        </span>
                        <span className="meta-item">
                          <FaEye /> {post.views}
                        </span>
                      </div>
                      
                      <h3>{post.title}</h3>
                      <p className="excerpt">{post.excerpt}</p>
                      
                      <div className="author-info-v2">
                        <div className="author-avatar-v2">
                          <FaUser />
                        </div>
                        <div>
                          <strong>{post.author}</strong>
                          <span>Specialist Doctor</span>
                        </div>
                      </div>
                      
                      <div className="card-actions-v2">
                        <button className="read-btn-v2">
                          Read Article <FaArrowRight />
                        </button>
                        <div className="action-icons-v2">
                          <button className="icon-btn-v2" title="Save">
                            <FaBookmark />
                          </button>
                          <button className="icon-btn-v2" title="Share">
                            <FaShareAlt />
                          </button>
                          <button className="icon-btn-v2" title="Like">
                            <FaHeart /> {post.likes}
                          </button>
                        </div>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </section>

            {/* Recent Articles */}
            <section className="section-v2">
              <div className="section-header-v2">
                <h2>
                  <FaNewspaper className="icon" />
                  Recent Articles
                </h2>
                <div className="header-actions">
                  <select className="sort-select-v2">
                    <option>Sort by: Newest</option>
                    <option>Most Popular</option>
                    <option>Most Viewed</option>
                  </select>
                </div>
              </div>
              
              <div className="recent-grid-v2">
                {recentPosts.map((post) => (
                  <article key={post.id} className="recent-card-v2">
                    <div className="recent-image-v2">
                      <img src={post.image} alt={post.title} />
                      <div className="recent-category" style={{ backgroundColor: post.color }}>
                        {post.category}
                      </div>
                    </div>
                    
                    <div className="recent-content-v2">
                      <div className="recent-meta">
                        <span className="meta-item">
                          <FaCalendarAlt /> {post.date}
                        </span>
                        <span>•</span>
                        <span className="meta-item">
                          <FaClock /> {post.readTime}
                        </span>
                      </div>
                      
                      <h4>{post.title}</h4>
                      <p className="recent-excerpt">{post.excerpt}</p>
                      
                      <div className="recent-footer">
                        <div className="recent-author">
                          <FaUser />
                          <span>{post.author}</span>
                        </div>
                        <div className="recent-stats">
                          <span><FaHeart /> {post.likes}</span>
                          <span><FaEye /> {post.views}</span>
                        </div>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </section>
          </div>

          {/* Right Column - Sidebar */}
          <div className="sidebar-v2">
            {/* Search */}
            <div className="sidebar-widget-v2">
              <div className="search-box-v2">
                <FaSearch className="search-icon-v2" />
                <input 
                  type="text" 
                  placeholder="Search articles..." 
                  className="search-input-v2"
                />
              </div>
            </div>

            {/* Categories */}
            <div className="sidebar-widget-v2">
              <h3 className="widget-title-v2">
                <FaFilter />
                Categories
              </h3>
              <div className="categories-list-v2">
                {categories.map((category, index) => (
                  <a 
                    key={index} 
                    href="#" 
                    className={`category-item-v2 ${index === 0 ? 'active' : ''}`}
                  >
                    <div className="category-icon">
                      {category.icon}
                    </div>
                    <span className="category-name">{category.name}</span>
                    <span className="category-count">{category.count}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* Popular Posts */}
            <div className="sidebar-widget-v2">
              <h3 className="widget-title-v2">
                <FaChartLine />
                Popular Posts
              </h3>
              <div className="popular-posts-v2">
                {popularPosts.map((post, index) => (
                  <div key={post.id} className="popular-post-item">
                    <div className="popular-rank">{index + 1}</div>
                    <div className="popular-content">
                      <h4>{post.title}</h4>
                      <div className="popular-meta">
                        <span>{post.date}</span>
                        <span>•</span>
                        <span>{post.views} views</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Tags */}
            <div className="sidebar-widget-v2">
              <h3 className="widget-title-v2">
                <FaTag />
                Popular Topics
              </h3>
              <div className="tags-cloud-v2">
                {tags.map((tag, index) => (
                  <a key={index} href="#" className="tag-v2">
                    {tag}
                  </a>
                ))}
              </div>
            </div>

            {/* Newsletter */}
            <div className="sidebar-widget-v2 newsletter-v2">
              <div className="newsletter-icon">
                <FaNewspaper />
              </div>
              <h3>Stay Updated</h3>
              <p>Get weekly health insights delivered to your inbox</p>
              <div className="newsletter-form-v2">
                <input type="email" placeholder="Your email address" />
                <button className="subscribe-btn-v2">
                  Subscribe
                </button>
              </div>
            </div>

            {/* About */}
            <div className="sidebar-widget-v2 about-v2">
              <div className="hospital-info">
                <h3>Rockland Hospital</h3>
                <p className="hospital-tagline">Varanasi's Premier Neuro & Mother Child Centre</p>
                <p className="hospital-desc">
                  Providing exceptional healthcare in neurology, neurosurgery, 
                  infertility, and maternal health with advanced medical care.
                </p>
              </div>
              <div className="social-links-v2">
                <a href="#" className="social-link-v2" style={{ backgroundColor: '#1877F2' }}>
                  <FaFacebookF />
                </a>
                <a href="#" className="social-link-v2" style={{ backgroundColor: '#1DA1F2' }}>
                  <FaTwitter />
                </a>
                <a href="#" className="social-link-v2" style={{ backgroundColor: '#0077B5' }}>
                  <FaLinkedinIn />
                </a>
                <a href="#" className="social-link-v2" style={{ backgroundColor: '#E4405F' }}>
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="cta-section-v2">
        <div className="container-v2">
          <div className="cta-content-v2">
            <div className="cta-text">
              <h2>Need Medical Advice?</h2>
              <p>Consult with our expert doctors for personalized healthcare guidance</p>
            </div>
            <div className="cta-buttons-v2">
              <button className="cta-btn-v2 primary">
                <FaUser /> Book Consultation
              </button>
              <button className="cta-btn-v2 secondary">
                <FaComment /> Ask a Question
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;